
import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import {
    Link, useLocation,
} from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';

import appScreenshot from '../../assets/images/payroll.png';

import { connect } from 'react-redux';
import { Actions as CREATEACCOUNTACTIONS } from 'store/actions/createAccountActions';
import { Actions as WEBINARACTIONS } from 'store/actions/webinarActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import RegistrationForm from 'components/common/RegistrationForm'
import FeaturesSideBySide from 'components/features/FeaturesSideBySide'
import UkFeatures from 'components/features/UkFeatures'
import Team from 'components/team/Team'
import DarkScreenshotRight from './for/DarkScreenshotRight'
import LightScreenshotLeft from './for/LightScreenshotLeft'
import Pricing from 'components/pricing/PricingUk'
import Testimonials from 'components/testimonials/Testimonials'
import Security from 'components/security/Security'

import { format, addMinutes } from "date-fns";

import Vimeo from '@u-wave/react-vimeo';
import ReactPixel from 'react-facebook-pixel';
// import AddToCalendar from 'react-add-to-calendar';
import AddToCalendarHOC from 'react-add-to-calendar-hoc';

import 'react-add-to-calendar/dist/react-add-to-calendar.css'
import { CheckIcon, XMarkIcon, CalendarDaysIcon, GlobeEuropeAfricaIcon, CurrencyPoundIcon, UserGroupIcon, ShieldCheckIcon, ScaleIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline'

import {
    CalculatorIcon,
    CalendarIcon,
    CloudArrowUpIcon,
    LockClosedIcon,
    ServerIcon,
    CheckCircleIcon,
    UserCircleIcon,
    MapPinIcon,
    ClipboardDocumentCheckIcon,
    DevicePhoneMobileIcon,
    ClockIcon,
    ChartBarIcon,
    CreditCardIcon,
    DocumentChartBarIcon,
    CloudIcon,
    CogIcon,
    ListBulletIcon,
    ShieldCheckIcon as ShieldCheckIconSolid, DocumentIcon, ChartPieIcon,
} from '@heroicons/react/20/solid'


import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const EMAILLIST = 11
const tags = {
    ukSignUp: 56
}

const title = "Discover Buddy your new Payroll Companion",
    intro = "Do you value your team? Payroll compliance is not just a button click. It's a process that requires attention to detail and a deep understanding of the law. A payroll companion like Buddy makes this task a lot easier, from automated calculations to data-sync with integrated systems, Buddy's got your back.",
    description = "UK Payroll has never been easier. With Buddy's cloud UK Payroll Software, you can get payroll done quickly and efficiently."
// intro: "Rediscover the Joy of Payroll",

const painpoints = [
    {
        icon: <GlobeEuropeAfricaIcon className="h-6 w-6 text-white"/> ,
        name: 'Holistic Approach',
        description: "We view payroll as a collaborative process, involving multiple stakeholders. Buddy is designed to cater to each one's unique needs.",
    },
    {
        icon: <ArrowsRightLeftIcon className="h-6 w-6 text-white"/> ,
        name: 'Seamless Integrations',
        description: 'From accounting software to pension providers, our integrations ensure seamless operations.',
    },
    {
        icon: <UserGroupIcon className="h-6 w-6 text-white"/> ,
        name: 'User-Centric Design',
        description: "Whether you're an employee checking your payslip or a manager approving holidays, our platform is intuitive and user-friendly.",
    },
    {
        icon: <ShieldCheckIcon className="h-6 w-6 text-white"/> ,
        name: 'Unwavering Security',
        description: "Your data's safety is our top priority. With rigorous security measures, we ensure peace of mind.",
    },
]

const notfor = [
    "Employers who don't have a clue what they pay their employees",
    "Business Professionals who are happy to spend time on low-value tasks",
    "Business Professionals who don't care if salaries are issued correctly",
    "Business Professionals would rather slave themselves at night or on weekends instead of spending time with their loved ones",
]

const faqs = [
    {
        question: "I'm a Service Provider, can I use Buddy to provide payroll to clients?",
        answer:
            "Great question, yes, you can use Buddy to provide payroll services to your customer. We do offer special service provider features that enable you to provide your customer with dedicated client and employee portals to facilitate the payroll process as much as possible. You can visit our dedicated pages for service providers, for more details or setup a time to talk to our team.",
    },
    {
        question: "Do I need to be a payroll expert to use Buddy?",
        answer:
            "While anyone can sign up and use our payroll software, we are aware that UK Payroll is complex. While we provide detailed user guides, and embedded compliance, we highly recommend working with a professional. We do have a network of trusted partners that we can recommend, reach out to our team to find out more.",
    },
    {
        question: "Do you offer support and how does it work?",
        answer:
            "Support is a key part of any payroll software, it is critical that you find the right assistance whenever you need it. As we understand that payroll is mission-critical, we offer FREE chat and email support to help you on any queries that you may have when using our payroll solution. However, we do also provide detailed online user guides and certification courses to ensure you can proceed swiftly through payroll. We do have higher tier support packages, that include phone support and extended business hours.",
    },
    {
        question: "Do you offer onboarding and migration assistance?",
        answer:
            "While our software is easy enough that you should be able to get started without assistance, we understand that not every business may have the necessary resources and time to migrate their data. Hence we do offer optional on-boarding and training, reach out to our team so we can understand your requirements in more details.",
    },
    // More questions...
]

const forBlocks = [
    {
        for: "For The Team (Employees)",
        title: "Empowering Every Employee",
        backgroundColor: "employee",
        textColor: "employee",
        description: "At Buddy, we believe every team member deserves clarity and control. Our self-service dashboard and mobile app are designed with you in mind, ensuring you're always in the loop",
        mobileImage: {
            src: 'assets/images/[country]/mobile-app-leave.png',
            alt: "Product screenshot",
        },
        image: {
            src: "https://tailwindui.com/img/component-images/dark-project-app-screenshot.png",
            alt: "Product screenshot",
        },
        features: [
          {
            name: 'Self-Service Portal & App',
            description:
              'Access payslips, view holiday balances, apply for days off and update personal details. All in one place.',
            icon: UserCircleIcon,
          },
          {
            name: 'Remote Work',
            description: 'Clock-in/out from anywhere, ensuring flexibility. Buddy is built for the modern workforce.',
            icon: MapPinIcon,
          },
          {
            name: 'Accuracy',
            description: "Confident that pay will be issued accurately and on-time.",
            icon: CheckCircleIcon,
          },
      ]
    },

  {
    "for": "For Team Leaders",
    "title": "Leading with Confidence and Clarity",
    backgroundColor: "employee",
    textColor: "employer",
    "description": "Leadership is about making informed decisions. Buddy provides the insights and controls you need to lead effectively.",
    "image": {
      "src": 'assets/images/[country]/manager-approve-leave.png',
      "alt": "Team leader dashboard screenshot"
    },
    "features": [
      {
        "name": "Holiday Management",
        "description": "View and approve holiday applications seamlessly.",
        "icon": DevicePhoneMobileIcon
      },
      {
        "name": "Calendar Feed",
        "description": "Sync with Outlook or Google Calendar for team availability.",
        "icon": CalendarIcon
      },
      {
        "name": "Timesheet Control",
        "description": "Approve timesheets while retaining original clock-in data.",
        "icon": ClockIcon
      }
    ]
  },

  {
    "for": "For The Payroll Team",
    "title": "Simplifying Payroll, One Calculation at a Time",
    backgroundColor: "advisor",
    textColor: "advisor",
    "description": "Payroll is both an art and a science. With Buddy, you're equipped with tools that ensure accuracy, compliance, and efficiency.",
    "image": {
      "src": 'assets/images/[country]/payroll-calculation.png',
      "alt": "Payroll dashboard screenshot"
    },
    "features": [
      {
        "name": "Automated Calculations",
        "description": "Tax, National Insurance, Student Loans, and more. Buddy does the math for you.",
        "icon": CalculatorIcon
      },
      {
        "name": "Holiday Pay",
        "description": "Calculations based on 52-week data and 104-week look-back.",
        "icon": CalendarIcon
      },
      {
        "name": "Data Accuracy",
        "description": "Pre-approved data from managers reduces back-and-forth.",
        "icon": ClipboardDocumentCheckIcon
      }
    ]
  },
  {
    "for": "For Account & Finance Teams",
    "title": "Seamless Integration, Effortless Accounting",
    backgroundColor: "advisor",
    textColor: "employer",
    "description": "Financial clarity is paramount. Buddy integrates with top accounting platforms, ensuring a streamlined workflow.",
    "image": {
      "src": 'assets/images/[country]/accounting-integrations.png',
      "alt": "Accounting dashboard screenshot"
    },
    "features": [
      {
        "name": "Accounting Sync",
        "description": "Direct integrations with Xero, with Sage, Quickbooks, and Freshbooks on the horizon.",
        "icon": ChartBarIcon
      },
      {
        "name": "Payment Solutions",
        "description": "Generate BACS files or use Open Banking with Fyorin.",
        "icon": CreditCardIcon
      },
      {
        "name": "Detailed Reports",
        "description": "Dive into Excel reports for granular financial insights.",
        "icon": DocumentChartBarIcon
      }
    ]
  },
  {
    "for": "For IT Teams",
    "title": "Robust, Reliable, and Ready to Scale",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "Security, scalability, and customization are non-negotiable. Buddy's infrastructure ensures IT teams can focus on what matters.",
    "image": {
      "src": 'assets/images/[country]/aws-infrastructure-overview.png',
        width: 929,
        height: 519,
      "alt": "IT dashboard screenshot"
    },
    "features": [
      {
        "name": "Security",
        "description": "ISO27001 certified; annual penetration testing and multi-factor authentication.",
        "icon": ShieldCheckIconSolid
      },
      {
        "name": "Scalability",
        "description": "AWS Cloud Infrastructure ensures consistent performance.",
        "icon": CloudIcon
      },
      {
        "name": "Rest API",
        "description": "Connect Buddy with enterprise systems using our REST API.",
        "icon": CogIcon
      },
      {
        "name": "Audit Logs",
        "description": "Easily trace who did what and when, increasing accountability.",
        "icon": ListBulletIcon
      }
    ]
  },
  {
    "for": "For Management",
    "title": "Insights for Informed Decisions",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "Management thrives on clarity. Buddy's tools provide a comprehensive view of your organization's financial landscape.",
    "image": {
      "src": 'assets/images/[country]/dashboard-preview.png',
      "alt": "Management dashboard screenshot"
    },
    "features": [
      {
        "name": "Detailed Reports",
        "description": "Comprehensive payroll insights at your fingertips.",
        "icon": DocumentIcon
      },
      {
        "name": "Dashboards",
        "description": "Coming soon for even more in-depth analysis.",
        "icon": ChartPieIcon
      }
    ]
  }
]

function UkLanding({
    userInList,
    contactInList,
    saveLead,
    profile,
}) {

    const location = useLocation()

    const countryCode = location.pathname.split('/')[1]
    const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode: null

    useEffect(() => {
        // load initial data required for anywhere
        if (profile && profile.email) {
            contactInList({
                email: profile.email,
                // list: EMAILLIST
            })
        }
    }, [profile && profile.email]);


    return (

        <React.Fragment>
            {/*<Helmet>
                <title>{title}</title>
                <meta name="description" content={intro} />
                <link rel="canonical" href={`https://www.buddy.hr/uk`} />
                <html lang="en-GB" amp />
                <link rel="alternate" href="https://www.buddy.hr" hrefLang="en-MT" />
            </Helmet>*/}


            <div class="bg-white py-24 sm:py-32">
              <div class="mx-auto max-w-7xl px-6 lg:px-8">
                <div class="mx-auto max-w-2xl lg:text-center">
                  <p class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Buddy: Your Comprehensive Payroll Companion</p>
                  <p class="mt-6 text-lg leading-8 text-gray-600">In the world of payroll, details matter. But so do people. At Buddy, we've crafted a solution that balances both, ensuring that every stakeholder, from employees to IT teams, feels valued and empowered. Our platform isn't just about numbers; it's about nurturing relationships, streamlining processes, and building trust. Dive in to discover how Buddy becomes an integral part of your team, simplifying complexities and amplifying efficiencies.</p>

                  <h2 class="mt-12 text-lg font-semibold leading-7 text-orange-600">Why Buddy?</h2>
                </div>
                <div class="mx-auto mt-10 max-w-2xl sm:mt-20 lg:mt-20 lg:max-w-4xl">
                  <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
                      {painpoints.map((feature) => (
                            <div key={feature.name}  class="relative pl-16">
                              <dt class="text-base font-semibold leading-7 text-gray-900">
                                <div class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-orange-600">

                                    {feature.icon}

                                </div>
                                {feature.name}
                              </dt>
                              <dd class="mt-2 text-base leading-7 text-gray-600">{feature.description}</dd>
                            </div>

                        ))}
                  </dl>
                </div>
                <div class="mx-auto mt-12 max-w-2xl lg:text-center">
                    <h2 className="text-lg font-extrabold text-gray-900">Every organization is a complex web of interactions, decisions, and processes. See how Buddy seamlessly fits into each facet, enhancing productivity and ensuring satisfaction.</h2>
                </div>
              </div>
            </div>

            {forBlocks.map((block,index) => (
                index % 2 === 0 ? <DarkScreenshotRight key={block.for} content={block} country={country}/> : <LightScreenshotLeft key={block.for} content={block} country={country}/>
            ))}

            {/*<div className="bg-orange-100">
                <div className="max-w-7xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                    <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                        <span className="block text-xl">You may be a</span>
                        <span className="block">Business Professional that values your time</span>
                        <span className="block text-xl font-medium">and you've probably asked yourself this question over and over</span>
                    </h2>
                </div>
            </div>
            <div className="bg-orange-600">
                <div className="max-w-7xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                    <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                        <span className="block text-xl pr-10">How can I</span>
                        <span className="block">get payroll done...</span>
                        <span className="block text-xl mt-2 pl-10 font-medium">...without having to think about it?</span>
                    </h2>
                </div>
            </div>

            <div className="relative py-16 bg-white overflow-hidden">
                <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
                    <div className="relative h-full text-lg max-w-prose mx-auto" aria-hidden="true">
                        <svg
                            className="absolute top-12 left-full transform translate-x-32"
                            width={404}
                            height={384}
                            fill="none"
                            viewBox="0 0 404 384"
                        >
                            <defs>
                                <pattern
                                    id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width={404} height={384} fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)" />
                        </svg>
                        <svg
                            className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
                            width={404}
                            height={384}
                            fill="none"
                            viewBox="0 0 404 384"
                        >
                            <defs>
                                <pattern
                                    id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width={404} height={384} fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)" />
                        </svg>
                        <svg
                            className="absolute bottom-12 left-full transform translate-x-32"
                            width={404}
                            height={384}
                            fill="none"
                            viewBox="0 0 404 384"
                        >
                            <defs>
                                <pattern
                                    id="d3eb07ae-5182-43e6-857d-35c643af9034"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width={404} height={384} fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)" />
                        </svg>
                    </div>
                </div>
                <div className="relative px-4 sm:px-6 lg:px-8">
                    <div className="text-md max-w-prose mx-auto">
                        <h3>
                            <span className="block text-base text-center text-orange-600 font-semibold tracking-wide uppercase">
                                a little story
                            </span>
                        </h3>
                        <p className="mt-8 text-xl text-gray-500 leading-8">
                            If we go back to 2017, in sunny Malta, our founding partners were yet to meet.
                            Both had been invited to a meeting to help an Accounting firm solve a specific challenge.
                        </p>
                    </div>
                    <div className="mt-6 prose prose-orange prose-md text-gray-500 mx-auto">
                        <p>
                            The client the partners were set to meet had a primary desire.
                            For the payroll function within the Firm to become profitable and value adding, for client and the firm itself.
                            <p>
                            </p>
                            To achieve this any payroll solution had to solve the following challenges:
                        </p>
                        <ul role="list">
                            <li>Multiple team members can collaborate.</li>
                            <li>Give customers and staff visibility, reducing calls to the payroll team.</li>
                            <li>Data would flow into payroll seamlessly from client information or third party Time and Attendance solutions.</li>
                            <li>Includes an accounting integration that sends payroll journals with no more than 1 click</li>
                            <li>Not having complex manual end of year procedures.</li>
                            <li>Reduce the risk of losing client data held on a single on-premise device.</li>
                            <li>Not require significant training, every time they get a new team member or onboard a client.</li>
                        </ul>
                        <p>
                            Maybe these are challenges you can relate to.
                        </p>
                        <p>
                            Hence, David and Jonathan, who had just met had to come up with a solution.
                        </p>
                        <p>
                            When talking to, providers, business owners and other accounting firms, they often heard that it's not possible.
                        </p>
                        <p>
                            Often told that legacy desktop solutions that operated in silo, were the best.
                        </p>
                        <p>
                            However, both coming from a technical background, they both asked, but what can we do to change all this?
                        </p>
                        <p>
                            Before getting into how they changed things, let's look at a few myths they debunked.
                        </p>
                        <h2>Myths Debunked</h2>

                        <ul role="list">
                            <li>You need a PhD to do Payroll.</li>
                            <li>Payroll is an administrative function that gives no value to the business.</li>
                            <li>Leave and Timesheet management is very time consuming</li>
                            <li>Cloud Payroll Software is expensive</li>
                            <li>Business to Accountants take forever to issue payroll.</li>
                            <li>Payroll Providers leave you to your own devices to learn.</li>
                        </ul>
                    </div>
                </div>
            </div>*/}

            <div className="bg-orange-600">
                <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                    <div className="bg-white shadow-xl rounded-lg overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
                        <div className="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
                            <div className="lg:self-center">
                                <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                                    <span className="block">Discover, Buddy</span>
                                    <span className="block">Your new Payroll Companion</span>
                                </h2>
                                <p className="mt-4 text-lg leading-6 text-gray-900">
                                    Buddy does all the heavy lifting, so you can spend as little time as possible on your payroll, knowing that everything’s just how it should be.
                                </p>
                                <NavHashLink to="#leadForm"
                                    className="mt-8 bg-orange-600 border border-transparent rounded-md shadow px-5 py-3 inline-flex items-center text-base font-medium text-white hover:bg-orange-50"
                                >
                                    Discover Buddy
                                </NavHashLink>
                            </div>
                        </div>
                        <div className="-mt-6 aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1">
                            <img
                                className="transform translate-x-6 translate-y-6 rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-20"
                                src={appScreenshot}
                                alt="App screenshot"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/*<div className="bg-white">
                <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
                    <div className="max-w-3xl mx-auto text-center">
                        <h2 className="text-3xl font-extrabold text-gray-900">Buddy is</h2>
                        <p className="mt-4 text-lg text-gray-500">
                            A cloud payroll solution that puts you, the business professional first.
                            Giving you ease of mind that the numbers look good, without spending forever doing payroll.
                        </p>
                    </div>
                    <div className="mt-12 max-w-3xl mx-auto text-center">
                        <h2 className="text-3xl font-extrabold text-gray-900">Buddy is not for</h2>
                    </div>
                    <dl className="mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
                        {notfor.map((feature, index) => (
                            <div key={index} className="relative">
                                <dt>
                                    <XMarkIcon className="absolute h-6 w-6 text-red-500" aria-hidden="true" />
                                </dt>
                                <dd className="ml-9 text-base text-gray-500">{feature}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </div>*/}

            {/*<FeaturesSideBySide country="UK" />
            <UkFeatures />
            <Pricing />
            <Testimonials />*/}
            <Security />

            <div className="bg-gray-50">
                <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
                    <div className="max-w-3xl mx-auto divide-y-2 divide-gray-200">
                        <h2 className="text-center text-3xl font-extrabold text-gray-900 sm:text-4xl">Frequently asked questions</h2>
                        <dl className="mt-6 space-y-6 divide-y divide-gray-200">
                            {faqs.map((faq) => (
                                <Disclosure as="div" key={faq.question} className="pt-6">
                                    {({ open }) => (
                                        <>
                                            <dt className="text-lg">
                                                <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                                                    <span className="font-medium text-gray-900">{faq.question}</span>
                                                    <span className="ml-6 h-7 flex items-center">
                                                        <ChevronDownIcon
                                                            className={classNames(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform')}
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                </Disclosure.Button>
                                            </dt>
                                            <Disclosure.Panel as="dd" className="mt-2 pr-12">
                                                <p className="text-base text-gray-500">{faq.answer}</p>
                                            </Disclosure.Panel>
                                        </>
                                    )}
                                </Disclosure>
                            ))}
                        </dl>
                    </div>
                </div>
            </div>

            <Team />

            <div className="bg-orange-600">
                <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
                    <h2 className="text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10">
                        <span className="block">Book a call: See if Buddy <br/>is the right fit for you
</span>
                    </h2>
                    <a target="_blank" href="https://calendly.com/buddy-intro/uk" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-orange-600 bg-white hover:text-orange-500 hover:bg-orange-50 transition duration-150 ease-in-out sm:w-auto">
                        Book my spot
                    </a>
                    <p className="mt-4 text-xs leading-1 text-orange-200">We'll take 15min of your time to understand if you're someone our payroll solution can help. <br /> This is a no-commitment call and comes at no charge.</p>
                </div>
            </div>


        </React.Fragment>

    );
}

const mapStateToProps = (state) => {

    // const {
    //   myAgreements,
    // } = state.my

    const profile = state && state.my && state.my.profile || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

    const userInList = state.createAccount && state.createAccount.inList && state.createAccount.inList.find(item => item == EMAILLIST)

    const webinar = state.webinar

    const userSubscribedForWebinar = webinar && state.createAccount && state.createAccount.webinars && state.createAccount.webinars.find(item => item == webinar.webinarID)

    return {
        webinar,
        userInList,
        userSubscribedForWebinar,
        profile
        // showSidebar: state.sidebar.show,
        // loggedIn: state.my.profile ? true : false,
    }
}

const mapDispatchToProps = dispatch => ({
    contactInList: (data) => dispatch(CREATEACCOUNTACTIONS.contactInList(data)),
    saveLead: (data) => dispatch(CREATEACCOUNTACTIONS.saveLead(data)),
    addTag: (data) => dispatch(CREATEACCOUNTACTIONS.addTag(data)),
    setWebinar: (webinar) => dispatch(WEBINARACTIONS.setWebinar(webinar)),
    // getProfile: () => dispatch(MYACTIONS.getProfile()),
    // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
    // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UkLanding) 